import React from "react";

export default class InfoSpot extends React.Component {
    constructor( props ) {
        super(props);
    }

    render() {
        return (
            <div
                onClick={( ev ) => this.props.selectInfoSpot(ev, this.props.spot)}
                className={`info-spot  info-spot--${this.props.spot.type}`}
                style={{ top: this.props.spot.pos_y + '%', left: this.props.spot.pos_x + '%' }}>

                {!this.props.spot.isRoom && <div>{this.props.i + 1}</div>}

                {this.props.spot.isRoom && <div className="icon  icon--door">
                    <svg viewBox="0 0 560 467" xmlns="http://www.w3.org/2000/svg">
                        <path d="M342.21,124.49 C124.43,155.568 31.13,311.14 0,466.7 C77.785,357.78 186.65,308 342.21,308 L342.21,435.57 L560,217.79 L342.21,-2.84217094e-14 L342.21,124.49 Z"
                              fill="currentColor"/>
                    </svg>
                </div>}

            </div>
        );
    }

}
